import React, {useMemo} from "react";
import {FileSearchOutlined} from "@ant-design/icons";
import {Button, Modal, Tag} from "antd";
import {useState} from "react";
import {DetailModalContainer, DetailTitle} from "./SubCompanyPaymentContractDetail.styles";
import {FeeTypesContainer} from "components/company/subCompanyDetail/subCompanyPaymentContracts/subCompanyPaymentContractForm/SubCompanyPaymentContractForm.styles";
import {FeeTypeCard} from "components/company/subCompanyDetail/subCompanyPaymentContracts/subCompanyPaymentContractForm/components/FeeTypeCard";
import {paymentContractFeeTypes} from "constants/constants";
import {useStore} from "hooks/useStore";

export const SubCompanyPaymentContractDetail = ({
    subCompanyPaymentContract = {},
    visible,
    onClose
}) => {
    const [isVisible, setVisible] = useState(false);
    const stores = useStore();

    // visible verilmediğinde bileşen kendi tetikleyici butonunu ve görünürlüğünü yönetir;
    // verildiğinde modal dışarıdan kontrol edilir (ör. tablo satırından açılan tek modal)
    const isControlled = visible !== undefined;
    const isModalVisible = isControlled ? visible : isVisible;
    const handleClose = () => (isControlled ? onClose?.() : setVisible(false));

    const userIsCustomer = !stores.meStore.checkRole("notVisibleForCompanyUser");

    // feeItems'ı feeType'a göre grupla
    const organizedFeeItems = useMemo(() => {
        const feeItems = subCompanyPaymentContract?.feeItems || [];
        const organized = {};

        feeItems.forEach(item => {
            if (!organized[item.feeType]) {
                organized[item.feeType] = {default: null, custom: []};
            }
            // BONUS_PAKET_KAZANCI_UCRETI için tüm itemlar custom olarak gruplanır
            if (item.feeType === "BONUS_PAKET_KAZANCI_UCRETI") {
                organized[item.feeType].custom.push({
                    ...item,
                    options: {...item.options, isCustomTimed: true}
                });
            } else if (item.options?.isCustomTimed) {
                organized[item.feeType].custom.push(item);
            } else {
                organized[item.feeType].default = item;
            }
        });

        return organized;
    }, [subCompanyPaymentContract?.feeItems]);

    // Noop fonksiyonlar - read-only mod için
    const noop = () => {};

    return (
        <>
            {!isControlled && (
                <Button onClick={() => setVisible(true)} icon={<FileSearchOutlined />} />
            )}
            <Modal
                zIndex={1000}
                id="subCompanyPaymentContractDetailModal"
                visible={isModalVisible}
                title={
                    <DetailTitle>
                        Sözleşme Detayları{" "}
                        {subCompanyPaymentContract?.contractId ? (
                            <Tag style={{fontWeight: "normal"}}>
                                {subCompanyPaymentContract?.contractId}
                            </Tag>
                        ) : (
                            ""
                        )}
                    </DetailTitle>
                }
                onCancel={handleClose}
                cancelText="Kapat"
                okButtonProps={{style: {display: "none"}}}
                width={1400}
                centered
                bodyStyle={{overflowY: "auto", maxHeight: "70vh"}}
            >
                <DetailModalContainer>
                    {subCompanyPaymentContract?.description ? (
                        <div style={{marginBottom: 16}}>
                            <span style={{fontWeight: 600, marginRight: 8}}>Açıklama:</span>
                            <span>{subCompanyPaymentContract.description}</span>
                        </div>
                    ) : null}
                    <FeeTypesContainer>
                        {/* Sıralama: PAKET -> SAATLIK_UCRET -> KM -> SAATLIK_GARANTI_PAKET -> BONUS_PAKET */}
                        {paymentContractFeeTypes
                            .filter(ft => organizedFeeItems[ft.value] !== undefined)
                            .map(feeTypeInfo => {
                                const feeTypeValue = feeTypeInfo.value;

                                return (
                                    <FeeTypeCard
                                        key={feeTypeValue}
                                        feeType={feeTypeValue}
                                        feeTypeName={feeTypeInfo.name}
                                        defaultFeeItem={organizedFeeItems[feeTypeValue]?.default}
                                        customFeeItems={
                                            organizedFeeItems[feeTypeValue]?.custom || []
                                        }
                                        disabled={true}
                                        onDefaultChange={noop}
                                        onCustomItemChange={noop}
                                        onAddCustomItem={noop}
                                        onRemoveCustomItem={noop}
                                        onRemoveFeeType={null}
                                        userIsCustomer={userIsCustomer}
                                    />
                                );
                            })}
                    </FeeTypesContainer>
                </DetailModalContainer>
            </Modal>
        </>
    );
};
